import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/man-leaning-on-railing.webp';
import financialPlanningImageMobileWebp from './images/man-leaning-on-railing-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='life-insurance-financial-planning'
      themeType='lightTheme'
      backgroundVariant='lightB'
      moduleName='financial-planning-module'
      moduleVariation='A'
      disableBottomPadding={false}
      reverseContent
      // content
      subHeadingText={<>How much does life <WidowBlock>insurance cost&#63;</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            Many factors can affect the cost of your policy. That&#39;s why your advisor works closely with you. They&#39;ll ask deeper questions to understand your situation, needs, and budget. Then, recommend the best solutions for you. In general, what you pay each month (or year) depends on things like the type and amount of life insurance you get, your age, health, and if you{' '}
            <Link
              id='life-insurance-financial-planning-riders-link'
              variant='primaryDeemphasize'
              linkUrl='/life-insurance/life-insurance-riders/'
              ariaLabel='add any life insurance riders'>
              add riders
            </Link>.
          </Typography>
          <Link
            variant='buttonLinkPrimary'
            id='life-insurance-financial-planning-fafa-cta'
            linkUrl= '/find-a-financial-advisor/'>
            Connect with an advisor
          </Link>
        </>
      )}
      // image props
      imageAltText='A man leaning on a porch railing, looking out at the forest'
      imageSrcDefault={financialPlanningImageDesktopWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};
